export default __webpack_public_path__ + "static/media/32842 (1).8be60367.jpg";